export class DOM {
    static queryFurthestElement(currentElement, selector) {
        let closest = currentElement.closest(selector);
        let furthest = null;
        while (closest) {
            furthest = closest;
            if (closest.parentElement) {
                closest = closest.parentElement.closest(selector);
            }
        }
        return furthest;
    }
    static queryPreviousSibling(currentElement, selector) {
        let nextNode = currentElement;
        do {
            nextNode = nextNode.previousElementSibling;
            if (nextNode === null) {
                break;
            }
            else if (nextNode.matches(selector)) {
                return nextNode;
            }
        } while (nextNode !== null);
        return null;
    }
    static queryNextSibling(currentElement, selector) {
        let nextNode = currentElement;
        do {
            nextNode = nextNode.nextElementSibling;
            if (nextNode === null) {
                break;
            }
            else if (nextNode.matches(selector)) {
                return nextNode;
            }
        } while (nextNode !== null);
        return null;
    }
}
export default DOM;
